<template>
  <b-container v-if="this.$root.signedIn" class="pt-3">
    <b-row>
      <b-col cols=12>
        <b-card no-body class="mb-1" style="width:100%">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion1 variant="primary">
              Search Criteria
              <font-awesome-icon icon="caret-down" size="lg" v-if="!showSearch"/> 
              <font-awesome-icon icon="caret-up" size="lg" v-if="showSearch"/>
            </b-btn>
          </b-card-header>
          <b-collapse id="accordion1" visible accordion="accordion1" role="tabpanel" v-model="showSearch">
            <b-row v-if="!printing" class="pt-2">
              <b-col>
                <scoring-event-search 
                  :skip = "{
                    programme: true,
                    year: true,
                  }" 
                  :multiple = "{
                    region: true,
                    industry: true
                  }"
                  @update:customer = "customer = $event"
                  @update:industry = "industries = $event" 
                  @update:country = "country = $event"
                  @update:region = "regions = $event"
                  @update:gear = "gear = $event"
                />
              </b-col>
              <b-col>
                <b-container>
                  <b-card>
                    <h4>GPC Session</h4>
                    <b-row class="text-left pt-2">
                      <label for="date">Date</label> 
                    </b-row>
                    <b-row>
                      <datepicker v-model="from_date" id="date" :disabled-dates="{'from': new Date()}" :clear-button="true"/> 
                      <div class="pl-2 pr-2">to</div>
                      <datepicker v-model="to_date" id="date" :disabled-dates="{'from': new Date()}" :clear-button="true"/>
                    </b-row>
                    <b-row class="text-left pt-2">
                      <label for="date">Person</label> 
                    </b-row>
                    <b-row>
                      <b-form-input v-model="partial_name" class="mb-3" placeholder="Name...." id="person"/>
                    </b-row>
                    <b-row class="text-left pt-2">
                      <label>Keywords</label> 
                    </b-row>
                    <b-row>
                      <b-col class="text-left">
                      <vue-tags-input v-model="keyword" :tags="keywords" @tags-changed="newTags => keywords = newTags" placeholder="Add keywords..." />
                      </b-col>
                    </b-row>
                    <b-row class="text-center pt-2">
                      <b-col>
                        <toggle-button id="keywordIsAnd" v-model="keywordIsAnd" :labels="{checked: 'Match ALL keywords', unchecked: 'Match ANY keywords'}" :width="150" :height="40" :switch-color="{checked: '#0069D9', unchecked: '#218838'}" :color="{checked: '#278fff', unchecked: '#30c651'}"/>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-container>
              </b-col>
            </b-row>
            <b-row class="pt-3 pb-3">
              <b-col class="text-center">
                <b-button variant="success" @click="search()" v-if="!searching">Search</b-button>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>
        <b-tabs v-model="tabIndex">
          <b-tab title="Results" v-if="!printing">
            <div v-if="!searching">
              <table class="table table-striped" v-if="results">
                <thead>
                  <tr>
                    <th class="text-left">Customer</th>
                    <th>Gear</th>
                    <th class="text-left">Session</th>
                    <th>Problem</th>
                    <th/>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in results" :key="item.id" class='c'>
                    <td class="text-nowrap text-left">
                      <b>{{ item.customer.name }}</b>
                      <br>
                      {{ item.customer.country }}
                      <br v-if="item.customer.region">
                      {{ item.customer.region }}
                      <br>
                      {{ item.customer.industry }} 
                      <br v-if="item.customer.secondary_industry">
                      {{ item.customer.secondary_industry }} 
                    </td>
                    <td>{{ item.gear }}</td>
                    <td class="text-nowrap text-left">
                      <b>{{ item.session_date | moment('dddd, MMMM Do YYYY') }}</b>
                      <br>
                      Coach: {{ item.coach_name }} 
                      <br>
                      Owner: {{ item.responsible_name }}
                    </td>
                    <td><span v-html="item.problem"/></td>
                    <td>
                      <b-button-group vertical>
                        <b-button variant="secondary" @click="session = item; tabIndex = 1;">View</b-button>
                        <b-button variant="primary" @click="$emit('edit-gpc', item);">Edit</b-button>
                        <vue-confirmation-button ref="deleteButton" :css="'btn btn-danger sm'" :messages="['Delete','Are you sure?','Deleted, reloading.....']" @confirmation-success="deleteItem(item);"/>
                      </b-button-group>
        
                      
                    </td>
                  </tr>
                  <tr class='c' v-if="!total">
                    <td colspan=100>No results</td>
                  </tr>
                </tbody>
              </table>
              <b-pagination size="sm" :total-rows="total" v-model="page" :per-page="pageSize" v-if="total > 0"/>
            </div>
          </b-tab>
          <b-tab title="Session View" v-if="session">
            <div id="gpc-session-view">
              <b-row class="mb-5">
                <b-col cols=4>&nbsp;</b-col>
                <b-col>
                  <span class="align-bottom"><b-img center fluid src="/static/traction.png" /></span>
                </b-col>
                <b-col cols=4>&nbsp;</b-col>
              </b-row>
              <b-row class="pb-2 text-center">
                <b-col cols=1>&nbsp;</b-col>
                <b-col class="text-left">
                  <h2 class="gpc-title text-left">Record of Group Performance Coaching (GPC) session</h2>
                </b-col>
              </b-row>
              <b-row class="pb-3">
                <b-col cols=1>&nbsp;</b-col>
                <b-col class="text-left">
                  This is completed by the coach during the session and given to the problem owner to follow up.
                </b-col>
              </b-row>
              <b-row>
                <b-col cols=1>&nbsp;</b-col>
                <b-col cols="2" class="text-left border-bottom">
                  Company:  
                </b-col>
                <b-col class="text-left border-bottom">
                  {{ session.customer.name }}
                </b-col>
                <b-col cols=1>&nbsp;</b-col>
              </b-row>
              <b-row class="pt-3">
                <b-col cols=1>&nbsp;</b-col>
                <b-col cols="2" class="text-left border-bottom">
                  Date of session: 
                </b-col>
                <b-col class="text-left border-bottom">
                  {{ session.session_date | moment('Do MMMM YYYY') }}
                </b-col>
                <b-col cols=1>&nbsp;</b-col>
              </b-row>
              <b-row class="pt-3">
                <b-col cols=1>&nbsp;</b-col>
                <b-col cols="2" class="text-left border-bottom">
                  Problem owner:
                </b-col>
                <b-col class="text-left border-bottom">
                  {{ session.responsible_name }} ({{ session.responsible_role }})
                </b-col>
                <b-col cols=1>&nbsp;</b-col>
              </b-row>
              <b-row class="pt-3">
                <b-col cols=1>&nbsp;</b-col>
                <b-col cols="2" class="text-left border-bottom">
                  GPC Coach:
                </b-col>
                <b-col class="text-left border-bottom">
                  {{ session.coach_name }}
                </b-col>
                <b-col cols=1>&nbsp;</b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols=1>&nbsp;</b-col>
                <b-col cols="1" class="border">
                  <div class="verticaltext">
                    <span class="verticaltext_content1">Group Members</span>
                  </div>
                </b-col>
                <b-col class="text-left border">
                  <div v-html="session.participants" class="pt-2 pr-2 pb-2"/>
                </b-col>
                <b-col cols=1>&nbsp;</b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols=1>&nbsp;</b-col>
                <b-col cols="1" class="border">
                  <div class="verticaltext w-50">
                    <span class="verticaltext_content2">Problem</span>
                  </div>
                </b-col>
                <b-col class="text-left border">
                  <div v-html="session.problem" class="pt-2 pr-2 pb-2"/>
                </b-col>
                <b-col cols=1>&nbsp;</b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols=1>&nbsp;</b-col>
                <b-col cols="1" class="border">
                  <div class="verticaltext">
                    <span class="verticaltext_content3">Actions</span>
                  </div>
                </b-col>
                <b-col class="text-left border">
                  <div v-html="session.actions" class="pt-2 pr-2 pb-2"/>
                </b-col>
                <b-col cols=1>&nbsp;</b-col>
              </b-row>
              <b-row class="pt-3">
                <b-col cols=1>&nbsp;</b-col>
                <b-col class="text-left" style="font-weight: bold;">
                  NEXT STEP -  <span v-html="session.next_step"/>
                </b-col>
                <b-col cols=1>&nbsp;</b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
        <b-row class="pt-5 pb-5 text-right">
          <b-button @click="print();" v-if="session" class="align-self-right">Print</b-button>     
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// @ is an alias to /src
import Datepicker from 'vuejs-datepicker';
import VueTagsInput from '@johmun/vue-tags-input';
import { gearDef } from '@/services/constants';
import ScoringEventSearch from '@/components/ScoringEventSearch.vue';
import * as API from '@/services/API';
import { Printd } from 'printd';
import vueConfirmationButton from 'vue-confirmation-button';
import ToggleButton from 'vue-js-toggle-button/src/Button';

export default {
  name: "GPCSearch",
  components: {
    Datepicker,
    VueTagsInput,
    vueConfirmationButton,
    ScoringEventSearch,
    ToggleButton
  },
  watch: {
    page: {
      handler(newData) {
        if (newData) this.search();
      }
    }
  },
  data: function() {
    return {
      customer: null,
      industries: null,
      country: null,
      regions: null,
      gear: null, 
      keywords: [],
      keyword: '',
      keywordIsAnd: false,
      partial_name: null,
      searching: false,
      results: [],
      total: 0,
      page: 1,
      pageSize: 20,
      displayType: 'table',
      from_date: null,
      to_date: null,
      session: null,
      printing: false,
      showSearch: true,
      tabIndex: 0
    }
  },
  methods: {
    print() {
      const printer = new Printd();
      printer.print(document.getElementById('gpc-session-view'), '', function(win, doc, node, launchPrint) {
        // Get style elements
        const styles = [].slice.call(document.getElementsByTagName('style'));
        const links = [].slice.call(document.getElementsByTagName('link'));
        // append them to the the new document head element
        styles.forEach(styleElement => doc.head.appendChild(styleElement.cloneNode(true)));
        links.forEach(linkElement => doc.head.appendChild(linkElement.cloneNode(true)));
        const styleElement = doc.createElement('style');
        const innerStyle = doc.createTextNode('.footer { position: absolute; bottom: 0px; }');
        styleElement.appendChild(innerStyle);
        doc.head.appendChild(styleElement);
        setTimeout(() => launchPrint(win), 1000)
      });
    },
    deleteItem(item) {
      return API.deleteGPCSession(item.customer.id, item.id).then(results => {
        this.search();
      });
    },
    search() { 
      this.searching = true;
      this.showSearch = false;
      this.tabIndex = 0;
      this.session = null;
      const searchBody = {
        industries: this.industries,
        partial_name: this.partial_name,
        gear: this.gear,
        country: this.country,
        regions: this.regions,
        keywordType: this.keywordIsAnd ? 'and' : 'or',
        customer_id: (this.customer || {}).id,
        keywords: this.keywords.map(keyword => keyword.text),
        page: this.page,
        pageSize: this.pageSize,
        from_date: this.from_date,
        to_date: this.to_date
      };
      
      // clean out nulls
      Object.keys(searchBody).forEach(field => {
        if (!searchBody[field] || searchBody[field].length === 0) delete searchBody[field];
      });
      
      // do actual search
      API.searchGPCSessions(searchBody).then(results => {
        this.total = results.body.total;
        this.searching = false;
        this.results = results.body.results.map(row => {
          row.gear = Object.keys(gearDef).reduce((accumulator, percentage) => {
            if (row.score >= percentage) return gearDef[percentage];
            return accumulator;
          }, 0);
          return row;
        });
      });
    }
  }
}
</script>
<style>
.buttonbar {
  padding-top: 4em;
  padding-bottom: 4em;
}
.gpc-title {
  font-family: Stag-Black;
  font-weight: bold;
  color: #EE3124;
  font-weight: bold;

}
.sf-copy {
  font-family: Stag-Book;
  color: #EE3124 !important;
  font-weight: bold;
  vertical-align: text-bottom
}
.verticaltext {
    position: relative; 
    padding-left:0px;
    padding-top: 20px;
    margin:1em 0;
    min-height:100px;
    font-family: Stag-Sans-Book;
}
.verticaltext_content1 {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
    position: absolute;
    left: -55px;
    padding-right: 60px;
    white-space:nowrap;
    font-family: Stag-Sans-Book;
}
.verticaltext_content2 {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
    position: absolute;
    left: 0px;
    font-family: Stag-Sans-Book;
}
.verticaltext_content3 {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
    position: absolute;
    left: 0px;
    font-family: Stag-Sans-Book;
}
</style>



// WEBPACK FOOTER //
// src/components/GPCSearch.vue